export let launchHeader = {
	bgColor: '',
	color: '',
	description: '',
	startConversation: '',
};
